<template lang="html">
  <div
    :is="tag"
    class="teaser-item"
  >
    <a
      v-if="isExternalLink"
      :href="linkTo"
      class="teaser-item__link"
    >
      <div class="teaser-item__content">
        <p
          class="teaser-item__headline"
          v-html="item.columns.title"
        />
        <p
          class="teaser-item__paragraph"
          v-html="item.columns.text"
        />
      </div>
      <ArrowIcon class="teaser-item__icon" />
    </a>
    <AppLink
      v-else
      :is-link="linkTo && linkTo.url"
      :to="linkTo && linkTo.url"
      class="teaser-item__link"
    >
      <div class="teaser-item__content">
        <p
          class="teaser-item__headline"
          v-html="item.columns.title"
        />
        <p
          class="teaser-item__paragraph"
          v-html="item.columns.text"
        />
      </div>
      <ArrowIcon class="teaser-item__icon" />
    </AppLink>
  </div>
</template>

<script>
import { Resource } from 'beisheim/models'
import ArrowIcon from 'beisheim/assets/images/icons/teaser-item-arrow.svg'
import AppLink from 'beisheim/components/elements/app-link'

export default {
  components: {
    ArrowIcon,
    AppLink
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    tag: {
      type: String,
      default: () => 'div'
    }
  },
  computed: {
    isExternalLink () {
      const pattern = /^((http|https|ftp):\/\/)/
      return pattern.test(this.item.columns.link_to)
    },
    linkTo () {
      if (this.isExternalLink) {
        return this.item.columns.link_to
      }
      return Resource.query().where('id', this.item.columns.link_to).first()
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/grid';
  @import 'beisheim/scss/font';
  @import 'beisheim/scss/breakpoints';

  .teaser-item {
    @include font(1);
    @include grid-spacing(padding-left, 2);
    @include grid-spacing(padding-right, 2);
    padding-top: scale(10);
    padding-bottom: scale(10);
    border-bottom: 1px solid gray(3);
    transition: background-color 200ms ease-in-out;

    @include from(3) {
      @include font(0.5);
      @include grid-spacing(padding-left, 1);
      @include grid-spacing(padding-right, 1);
    }
    &:first-child {
      border-top: 1px solid gray(3);
    }
    &:last-child {
      border-bottom: 1px solid gray(3);
    }

    &:hover {
      background-color: gray(4);
      .teaser-item__icon {
        transform: translateX(10px);
      }
    }

  }

  .teaser-item__headline {
    @include font(3);
    margin-bottom: scale(4);
    @include from(3) {
      @include font(1.5);
    }
  }

  .teaser-item__link {
    display: flex;
    align-items: center;
  }

  .teaser-item__content {
    flex: 1;
  }

  .teaser-item__icon {
    width: 2rem;
    margin-left: 1rem;
    fill: gray(2);
    transition: transform 200ms ease-in-out;
  }
</style>
